import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { PAYMENT_DEPOSIT_ACCOUNT_QUERY } from "./schema";

import type { ServerModel } from "./type";

export const usePaymentDepositAccountQuery = (hotelID: string): { paymentDepositAccount: ServerModel | undefined } => {
	const { data } = useCustomSuspenseQuery(PAYMENT_DEPOSIT_ACCOUNT_QUERY, { variables: { hotelID } });

	return {
		paymentDepositAccount: data?.paymentDepositAccount ?? undefined,
	};
};

usePaymentDepositAccountQuery.displayName = "usePaymentDepositAccountQuery";
